var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5939 7.99087L24.0091 4.40605C23.4677 3.86465 22.5899 3.86465 22.0485 4.40605L5.29168 21.1629C5.10554 21.349 4.97867 21.5861 4.92705 21.8442L4.02769 26.341C3.83368 27.311 4.68895 28.1663 5.65901 27.9723L10.1558 27.073C10.4139 27.0213 10.651 26.8945 10.8371 26.7083L27.5939 9.95147C28.1354 9.41007 28.1354 8.53228 27.5939 7.99087ZM24.1816 9.44258C24.442 9.18223 24.442 8.76012 24.1816 8.49977L23.5002 7.81836C23.2399 7.55801 22.8178 7.55801 22.5574 7.81836L21.464 8.91175L23.0883 10.536L24.1816 9.44258ZM21.2026 12.4216L19.5784 10.7974L9.39882 20.977C9.13848 21.2373 9.13848 21.6594 9.39883 21.9198L10.0802 22.6012C10.3406 22.8615 10.7627 22.8615 11.023 22.6012L21.2026 12.4216Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.3785f8b48e4160506670ac263df9ce7f.svg";
export { ForwardRef as ReactComponent };